// src/pages/guia/GuiaAfiliados.js
//
// Lista de negocios afiliados del Guía.

import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Card, Table, TableHead, TableRow, TableCell,
  TableBody, Chip, Alert, LinearProgress, Stack, Box,
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { guia as api } from '../../api/guiaApi';
import { useApp } from '../../context/AppContext';

export default function GuiaAfiliados() {
  const { notificar } = useApp();
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    api.afiliados()
      .then(r => setLista(r || []))
      .catch(e => notificar(e.mensajeUsuario || 'No se pudo cargar.', 'error'))
      .finally(() => setCargando(false));
  }, [notificar]);

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} mb={3}>
        <StorefrontIcon color="primary" sx={{ fontSize: 32 }} />
        <Box>
          <Typography variant="h4" fontFamily="Fraunces">Mis negocios afiliados</Typography>
          <Typography variant="body2" color="text.secondary">
            Los negocios que has traído a HolaVeci.
          </Typography>
        </Box>
      </Stack>

      {cargando ? <LinearProgress /> : lista.length === 0 ? (
        <Alert severity="info">
          Todavía no tienes negocios afiliados. Cuando un tendero escanee tu código QR,
          aparecerá aquí y empezará a generar comisiones si paga la mensualidad.
        </Alert>
      ) : (
        <Card>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Negocio</TableCell>
                <TableCell>Dirección</TableCell>
                <TableCell>Fecha afiliación</TableCell>
                <TableCell align="center">Negocio</TableCell>
                <TableCell align="center">Local</TableCell>
                <TableCell align="center">Estado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lista.map(a => (
                <TableRow key={a.empresaId} hover>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600}>
                      {a.nombreComercial || a.razonSocial}
                    </Typography>
                    {a.nombreComercial && a.nombreComercial !== a.razonSocial && (
                      <Typography variant="caption" color="text.secondary">{a.razonSocial}</Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">
                      {a.ubicacion?.direccion || '—'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {a.fechaAfiliacionGuia
                      ? new Date(a.fechaAfiliacionGuia).toLocaleDateString('es-CO')
                      : '—'}
                  </TableCell>
                  <TableCell align="center">
                    {a.contrataHolaVeci
                      ? <Chip label="Sí" size="small" color="primary" />
                      : <Chip label="No" size="small" variant="outlined" />}
                  </TableCell>
                  <TableCell align="center">
                    {a.contrataPOS
                      ? <Chip label="Sí" size="small" color="secondary" />
                      : <Chip label="No" size="small" variant="outlined" />}
                  </TableCell>
                  <TableCell align="center">
                    <Chip label={a.activa ? 'Activo' : 'Inactivo'} size="small"
                          color={a.activa ? 'success' : 'default'} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </Container>
  );
}
